import React from "react";
import { getRoleChangeConfig } from "../orgDesign.constants";
import { BridgeRowStyled, CardStyled, NumStyled, LabelStyled } from "./OrgDesignSummaryBridge.styles";

// Role Count breakdown: `cards` comes from getRoleCountCards (Baseline,
// Created, AI Augmented or Increased, Reduced, Redundant). Kept separate
// from the headcount bridge, since Augmented has no −/+/= slot in that
// equation. Same cards as the bridge, without the operators.
const OrgDesignRoleCount = ({ cards, entryOption }) => (
  <BridgeRowStyled>
    {cards.map(({ key, label, count, status }) => (
      <CardStyled key={key}>
        <NumStyled $accentToken={status ? getRoleChangeConfig(status, entryOption).accentToken : undefined}>{count}</NumStyled>
        <LabelStyled>{label}</LabelStyled>
      </CardStyled>
    ))}
  </BridgeRowStyled>
);

export default OrgDesignRoleCount;
